module.exports = __webpack_public_path__ + "assets/movie/pozadina.mp4";